import { render, staticRenderFns } from "./ClassificacaoModal.vue?vue&type=template&id=b79d4a38"
import script from "./ClassificacaoModal.vue?vue&type=script&lang=js"
export * from "./ClassificacaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports